import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/shared/models/user.model';
import { Store } from 'src/app/core/store/store';
import { Router } from '@angular/router';
import { EventsService } from 'src/app/shared/services/events.service';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { IndexedDbService } from 'src/app/shared/services/indexed-db.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnInit{
  recaptchaToken;
  url = environment.apiBaseUrl;

  constructor(private http: HttpClient, private store: Store, private indexedDbService: IndexedDbService, private router: Router, private eventsService: EventsService, private toaster: ToastrService) {
    // this.getCaptchaToken();
  }
  ngOnInit(): void {
  }

  login(body: any, captcha: string) {
    const headers = new HttpHeaders({
      'g-recaptcha-response': `${captcha}`
    });
    return this.http.post<any>(`${this.url}users/login`, body,{headers})
      .pipe(map(response => {
        debugger
        let user = response && response.data
        if(user && (user.isIPJUser || (user.role == 'PARTNER_ADMIN') || (user.role == 'ADMIN'))) {
          localStorage.setItem('UPGRAD_IPJ_TOKEN', response.data.token);
          sessionStorage.setItem('UPGRAD_IPJ_TOKEN', response.data.token);
          this.indexedDbService.setToken(response.data.token);
          debugger
          localStorage.setItem('role', user.role);
          this.store.set('user', response.data);
        }
        return user ? user : null;
      }))

  }

  logout(user?, activationData?) {
    if (localStorage.getItem("UPGRAD_IPJ_TOKEN")) {
      this.http.post<{ data: User; result: number; msg: string }>(`${this.url}users/logout`, {})
        .subscribe(
          (res) => {
            try {
              this.captureLogoutEvent(user, activationData)
            } catch (err) {
              console.log(err);
            }
          },
          (err) => {
            console.log(err);
          },
          () => {
            localStorage.clear();
            this.store.set('user', null);
            this.store.set('activation', null);
            this.router.navigate(["/login"]);
          }
        );
    }
  }

  logoutByEmail(body: any){
    return this.http.post<any>(`${this.url}users/logout-by-email`, body)
      .pipe(map(response => {
        return null;
      }))
  }

  IsEmailExist(email: string) {
    return this.http.get<{ data: boolean, result: number, msg: string }>(`${this.url}users/is-email-exists?email=${email}`).pipe(map(res => res.data));
  }

  captureLogoutEvent(user, activationData) {
    // capture event
    if(user && activationData){
      let eventData = { 'user': user, 'activationData': activationData }
      this.eventsService.logoutEvent(eventData);
    }
  }

  ssoAuth(token, templateName = "", tokenType, pathwayType ="") {
    if (!tokenType) tokenType = "oktaSSO"
    this.http.post<{ data: User, result: number, msg: string }>(`${this.url}users/login`, { token, tokenType, templateName }).subscribe(
      res => {
        this.getUser(res.data)
        //this.toaster.success('SSO Auth Successful');
        if (templateName && pathwayType == "pathway") {this.router.navigate([`/pathways/${templateName}`])}
        else if (templateName) {this.router.navigate([`/courses/${templateName}`])}
        else this.router.navigate(['/dashboard']);
      },
      err => {
        console.log(err);
      },
      () => console.log("SSO Complete service complete")
    )
  }

  passwordResetOTP(data){
    return this.http.post<any>(`${this.url}users/send-otp`, data)
      .pipe(map(response => {
        // let user = response && response.data
        // if(user && user.isIPJUser) {
          // localStorage.setItem('token', response.data.token);
          // this.store.set('user', response.data);
        // }
        return response;
      }))

  }
  resetPassword(data){
    return this.http.post<any>(`${this.url}users/new-password`, data)
    .pipe(map(response => {
      // let user = response && response.data
      // if(user && user.isIPJUser) {
        // localStorage.setItem('token', response.data.token);
        // this.store.set('user', response.data);
      // }
      return response;
    }))
  }

  getUser(user: User | null = null) {
    if (user) {
      localStorage.setItem('UPGRAD_IPJ_TOKEN', user.token);
      sessionStorage.setItem('UPGRAD_IPJ_TOKEN', user.token);
      this.indexedDbService.setToken(user.token);
      this.store.set('user', user);
    }
    else if (localStorage.getItem("token")) {
      this.http.get<{ data: User, result: number, msg: string }>('users/self').subscribe(
        res => {
          this.store.set('user', res.data);
          localStorage.setItem("UPGRAD_IPJ_TOKEN", res.data.token)
        },
        err => {
          console.log(err);
          this.store.set('user', null)
        }
      )
    }
    else {
      this.store.set('user', null)
    }
  }

  getByAcademyOrgId(SSOId: String) {
    if(SSOId){
    let url = this.url + 'sso/getByAcademyOrgId'
    console.log(url);
    return this.http.get(`${this.url}sso/getByAcademyOrgId?id=${SSOId}`);
    }else{
      console.error('SSOId is required');
    }

  }
}
